import PropTypes from 'prop-types';
import {translate} from 'react-switch-lang';
import React, {Fragment, Component} from 'react';
import {
    Card, Row, Col, ListGroupItem, ListGroup, Input
} from 'reactstrap';
import Select from "react-select";
import {login,getLanguage,getMail,getPassword,getTemporaryAuth, getAllowFilter} from '../../../Auth';
import {server_host,server_host_api,getLanguageApi,select_style,} from "../../../Utils";
import axios from 'axios';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {toast} from 'react-toastify';
import LaddaButton, {
    ZOOM_IN
} from 'react-ladda';
import {faArrowRight} from '@fortawesome/free-solid-svg-icons';
// import InfiniteScroll from "react-infinite-scroll-component";
// import Loader from 'react-loaders';


class SelectCustomer extends Component {
    constructor(props) {
        super(props);

        this.state = {
            windowLoading: false,
            auth: [],
            companies : [],
            accessLoading: false,
            progress: 0,
            filterString: null,
            companiesCopy: [],
            status: "ACT",
            comboStatus: [{value: "ACT", label:"Ativas"},{value: "ICT", label:"Inativas"},{value: "TDS", label:"Todas",}],
            nameStatus: "Ativa",
            plan: "",
            comboPlan: [{value: "Advanced", label:"Advanced"},{value: "Enriquecimento", label:"Enriquecimento"},{value: "Enterprise", label:"Enterprise"},{value: "Initial", label:"Initial"},{value: "Premium", label:"Premium"},{value: "Smart", label:"Smart"}],
            namePlan:"Escolha um Plano",
            allow_filter:getAllowFilter()
        }; 
    }

    goCompany (id) {
        const { t } = this.props;

        this.setState(prevState => ({
            accessLoading: {
                ...prevState.accessLoading,
                [id]: true
            }
        }));

        let tmpSendingLanguage = null;

        if (getLanguage() === "pt") {
            tmpSendingLanguage = "pt-br";
        } else {
            tmpSendingLanguage = getLanguage();
        }

        axios.post(`${server_host}/api/token/`,{
            "email": getMail(),
            "password": getPassword(),
            "language": tmpSendingLanguage,
            "customer_id": id
        },{
            headers: { "Accept-Language": getLanguageApi() }
        })
        .then(res => {
            if (res.status === 200) {
                this.setState({
                    auth: res.data 
                });

                if (res.data.data.customer_id !== null) {
                    // Conseguiu logar no cliente
                    login(this.state.auth).then(res => {
                        if(res === true) {
                            this.setState(prevState => ({
                                accessLoading: {
                                    ...prevState.accessLoading,
                                    [id]: false
                                }
                            }));
                            this.props.history.push("/platform");
                        }
                        else {
                            this.setState(prevState => ({
                                accessLoading: {
                                    ...prevState.accessLoading,
                                    [id]: false
                                }
                            }));

                            toast.error(<div><b>{t('logon.logon_error')}</b><br /> {t('logon.logon_error_msg')}</div>);
                        }
                    });
                } else {
                    toast.error(<div><b>{t('logon.logon_error')}</b><br /> {t('logon.logon_error_msg')}</div>);
                }
            } else {
                this.setState(prevState => ({
                    accessLoading: {
                        ...prevState.accessLoading,
                        [id]:false
                    }
                }));
                
                toast.error(<div><b>{t('logon.logon_error')}</b><br /> {t('logon.logon_error_msg')}</div>);
            }
        })
        .catch(error => {
            this.setState(prevState => ({
                accessLoading: {
                    ...prevState.accessLoading,
                    [id]: false
                }
            }));
            toast.error(<div><b>{t('logon.logon_error')}</b><br /> {t('logon.logon_error_msg')}</div>);
        });
    }

    async componentDidMount () {
        this.getCompaniesTable();
    }

    handleStatus = (status) => {
        this.setState({ 
            status: status.value,
            nameStatus: status.label
          },() => this.fetchCompanies());
    }

    handlePlan = (plan) => {
        this.setState({ 
            plan: plan.value,
            namePlan: plan.label
          },() => this.fetchCompanies());
      }


    async fetchCompanies(handleRetrievedData) {
        const { t } = this.props;

        this.setState({
            windowLoading: true
        });

        let paramsObject = {
            status: this.state.status !== "TDS" ? this.state.status: null,
            plan_name: this.state.plan !== "" ? this.state.plan : null
          };

        await axios.get(`${server_host_api}/simple_customer/`,{
            headers: { Authorization: getTemporaryAuth()},
            params: paramsObject
         }
        )
        .then(res => {
            if (res.status === 200) {
                this.setState({
                    companies: res.data.data,
                    windowLoading: false,
                    companiesCopy: res.data.data
                })
            
            } else {
                toast.error(<div><b>{t('get_no_data')}</b><br /> {t('refresh_screem')}</div>);
            }
        })
        .catch(error => {
            toast.error(<div><b>{t('get_no_data')}</b><br /> {t('refresh_screem')}</div>);
        });
    }

    getCompaniesTable () {
        this.fetchCompanies((res) => {            
            this.setState({
                companies: res,
                windowLoading: false,
                companiesCopy: res
            })
        })
    }

    filterChange(e){

        if (e.target.value.length >= 3) {
            let filteredArray = [];
            this.state.companiesCopy.filter(company => company.company_name.toLowerCase().includes(e.target.value.toLowerCase()))
            .map(filteredItem => {
                filteredArray.push(filteredItem)

                return this.setState({
                    companies: filteredArray,
                })
            })
        } else {            
            return this.setState({
                companies: this.state.companiesCopy
            }) 
        }
    }

    render() {
        const { t } = this.props;

        const {
            comboPlan, 
            comboStatus
        } = this.state;

        return (
            <Fragment>
                <Row className="no-gutters h-100">
                    <Col lg="12" md="12" className="d-flex bg-white justify-content-center align-items-center pt-5">
                        <Col lg="6" md="10" sm="12" className="mx-auto app-login-box">
                            <div className="app-logo"/>
                            {this.state.allow_filter === "true" ?
                            <div className="widget-content-right mr-3 d-flex">                            
                            <div className="d-flex align-items-center" style={{marginLeft: "1rem", marginRight: "0.4rem", color: "#3ac47d"}} >
                                {t("Status: ")}
                             </div>    
                            <div style={{width: "220px"}}>
                            <Select
                                value={this.state.status}
                                onChange={this.handleStatus}
                                options={comboStatus}
                                placeholder={this.state.nameStatus}
                                styles={select_style}
                                classNamePrefix="select"
                                noOptionsMessage={() =>
                                  t("accounts.no_filter_options")}   
                                color={{color:"hsl(0,0%,40%)"} }    
                                />
                            </div>
                            <div className="d-flex align-items-center" style={{marginLeft: "1rem", marginRight: "0.4rem", color: "#3ac47d"}} >
                                {t("Plano: ")}
                             </div>
                            <div style={{width: "220px", marginLeft:"2px"}}>
                            <Select
                                value={this.state.plan}
                                onChange={this.handlePlan}
                                options={comboPlan}
                                placeholder={this.state.namePlan}
                                styles={select_style}
                                classNamePrefix="select"
                                noOptionsMessage={() =>
                                  t("accounts.no_filter_options")}   
                                color={{color:"hsl(0,0%,40%)"} }    
                                />
                               </div>
                            </div> 
                            : null }
                            <h4 style={{marginTop:"10px"}}>
                                <div>{t('selectcustomer.selectcustomer')}</div>
                            </h4>
                            <h6 className="mt-3">
                                {t('selectcustomer.message')}
                            </h6>
                            <Row className="divider"/>
                            <Input
                                type="text"
                                value={this.state.filterString}
                                onChange={this.filterChange.bind(this)}
                                placeholder="Buscar cliente"
                                style={{marginBottom:"5px"}}
                            />
                            <div className="form-wizard-content">
                                <Card className="main-card mb-3 mt-3">                                    
                                    <ListGroup className="todo-list-wrapper" flush> 

                                        { this.state.companies.map( (item, index) => (                                          
                                            <ListGroupItem key={item.id}>
                                                <div className="todo-indicator bg-primary"/>
                                                <div className="widget-content p-0">
                                                    <div className="widget-content-wrapper">
                                                        <div className="widget-content-left ml-2">
                                                            <div className="widget-subheading">
                                                                { item.id }{" - "} {item.plan_name.toUpperCase()}
                                                            </div>
                                                            <div className="widget-heading">
                                                                    {item.registration_code != null ? item.registration_code.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5") : "-"}
                                                            </div>
                                                            <div className="widget-subheading">
                                                                {item.company_name}
                                                            </div>
                                                            
                                                        </div>
                                                        <div className="widget-content-right">
                                                            <LaddaButton className="border-0 btn-transition btn btn-primary" 
                                                                         onClick={() => this.goCompany(item.id)} 
                                                                         loading={this.state.accessLoading[item.id] || false} 
                                                                         data-style={ZOOM_IN}>
                                                                {t("selectcustomer.goclient")} 
                                                                <FontAwesomeIcon icon={faArrowRight} className="ml-2"/>
                                                            </LaddaButton>
                                                        </div>
                                                    </div>
                                                </div>
                                            </ListGroupItem>
                                        ))}
                                    </ListGroup>
                                </Card>
                            </div>
                        </Col>
                    </Col>
                </Row>
            </Fragment>
        );
    }
}

SelectCustomer.propTypes = {
    t: PropTypes.func.isRequired,
};

export default translate(SelectCustomer);